import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";
import type { ParsedTaxSubmissionDTO } from "./ParsedTaxSubmissionDTO";

export function useParseTaxSubmission() {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders({ method: "POST" });
    const { t } = useTranslation();

    const mutation = useMutation<ParsedTaxSubmissionDTO, Error, string>({
        mutationFn: async (fileContent: string) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/parse`,
                {
                    headers,
                    method: "POST",
                    body: JSON.stringify({
                        content: fileContent,
                    }),
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        meta: {
            errorMessage: t("errors.messages.parseTaxSubmission"),
        },
    });

    return mutation;
}
